var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"ssim",class:{loaded: _vm.loaded},attrs:{"src":_vm.baseSrc},on:{"load":function($event){_vm.loaded = true}}})}
var staticRenderFns = []

export { render, staticRenderFns }